import script from "./payCourseMoney.vue?vue&type=script&setup=true&lang=js"
export * from "./payCourseMoney.vue?vue&type=script&setup=true&lang=js"

import "./payCourseMoney.vue?vue&type=style&index=0&id=e1ec443a&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1ec443a"]])

export default __exports__